import { render, staticRenderFns } from "./BaseButtonAction.vue?vue&type=template&id=998c8a7c"
import script from "./BaseButtonAction.vue?vue&type=script&lang=js"
export * from "./BaseButtonAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports